import { createContext } from 'react'

const headContext = createContext(undefined)
headContext.displayName = 'InertiaHeadContext'

export default headContext
